import { render } from "./ForceAggregation.vue?vue&type=template&id=22bdd5b6&scoped=true"
import script from "./ForceAggregation.vue?vue&type=script&lang=js"
export * from "./ForceAggregation.vue?vue&type=script&lang=js"

import "./ForceAggregation.vue?vue&type=style&index=0&id=22bdd5b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22bdd5b6"]])

export default __exports__